import BTCookies from '../../common/cookies';

/*
 * usPrivacyString.js
 *
 * Implements class USPrivacyString
 *
 * The class contains the methods to get/set the usprivacy string
 * and a method to get the current version.
 *
 * The usprivacy string as the format: ”vnol” where
 *  v = version
 *  n = Notice Given
 *  o = OptedOut
 *  l = lspact (Limited Service Provider Agreement Covered Transaction)
 */

// eslint-disable-next-line max-len
// More info at https://github.com/InteractiveAdvertisingBureau/USPrivacy/blob/master/CCPA/US%20Privacy%20String.md#us-privacy-string-format

const VALID_STRING_REGEX = /^[1][nNyY-][nNyY-][nNyY-]$/;
const NOT_APPLICABLE_VALUE = '-';
const YES_VALUE = 'Y';
const NO_VALUE = 'N';

class USPrivacyString {
  constructor() {
    this.internalVersion = Date.now();

    const usprivacy = BTCookies.get('usprivacy') || '';
    this.version = parseInt(usprivacy.charAt(0), 10) || 1;
    this.explicitNoticeProvided = usprivacy.charAt(1) || NOT_APPLICABLE_VALUE;
    this.userOptedOut = usprivacy.charAt(2) || NOT_APPLICABLE_VALUE;
    this.lspaCoveredTransaction = usprivacy.charAt(3) || NOT_APPLICABLE_VALUE;
  }

  getExplicitNoticeProvided() {
    return this.explicitNoticeProvided;
  }

  setExplicitNoticeProvided(value) {
    if (value === true) {
      this.explicitNoticeProvided = YES_VALUE;
    } else if (value === false) {
      this.explicitNoticeProvided = NO_VALUE;
    } else {
      this.explicitNoticeProvided = NOT_APPLICABLE_VALUE;
    }

    this.setCookie();
  }

  getUserOptedOut() {
    return this.userOptedOut;
  }

  setUserOptedOut(value) {
    if (value === true) {
      this.userOptedOut = YES_VALUE;
    } else if (value === false) {
      this.userOptedOut = NO_VALUE;
    } else {
      this.userOptedOut = NOT_APPLICABLE_VALUE;
    }

    this.setCookie();
  }

  getVersion() {
    return this.version;
  }

  getUSPrivacyString() {
    return `${this.version}${this.explicitNoticeProvided}${this.userOptedOut}${this.lspaCoveredTransaction}`;
  }

  setCookie() {
    const usprivacy = this.getUSPrivacyString();
    if (VALID_STRING_REGEX.test(usprivacy)) {
      BTCookies.set('usprivacy', usprivacy);
      console.debug(`US Privacy String: "${usprivacy}"`);
    } else {
      console.error(`US Privacy String: "${usprivacy}" is invalid. Cookie will not be set.`);
    }
  }

  markCCPADoesNotApply() {
    this.explicitNoticeProvided = NOT_APPLICABLE_VALUE;
    this.userOptedOut = NOT_APPLICABLE_VALUE;
    this.lspaCoveredTransaction = NOT_APPLICABLE_VALUE;
    this.setCookie();
  }
}

const instance = new USPrivacyString();

export default instance;
